import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface ServiceStatusResult {
  ok: boolean;
  detail?: string;
}

/**
 * Strategy interface for a single "is this service alive" probe. Each service that should
 * appear on the status page implements one of these and registers itself as a
 * SERVICE_STATUS_CHECKS provider (see app.config.ts) — the status page never changes when a
 * new service is added.
 */
export interface ServiceStatusCheck {
  readonly key: string;
  readonly label: string;
  check(): Observable<ServiceStatusResult>;
}

/** Multi-provider token collecting every registered ServiceStatusCheck. */
export const SERVICE_STATUS_CHECKS = new InjectionToken<ServiceStatusCheck[]>('SERVICE_STATUS_CHECKS');
